import { useTranslation } from 'react-i18next';
import { Button } from '@sentinel/ui';

const sectionStyle: React.CSSProperties = {
  display: 'grid',
  gap: '0.75rem',
};
const statusRowStyle: React.CSSProperties = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.75rem',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export interface MfaSectionProps {
  enabled: boolean;
  onEnable: () => void;
  onDisable: () => void;
}

export function MfaSection({ enabled, onEnable, onDisable }: MfaSectionProps) {
  const { t } = useTranslation('security');
  return (
    <section style={sectionStyle} data-testid="mfa-section">
      <h2 style={{ margin: 0 }}>{t('mfa_section_title')}</h2>
      <div style={statusRowStyle}>
        <p
          style={{ margin: 0 }}
          data-testid="mfa-status"
          data-mfa-enabled={enabled ? 'true' : 'false'}
        >
          {enabled ? t('mfa_status_enabled') : t('mfa_status_disabled')}
        </p>
        {enabled ? (
          <Button
            type="button"
            variant="danger"
            onClick={onDisable}
            data-testid="mfa-disable-button"
          >
            {t('mfa_disable_button')}
          </Button>
        ) : (
          <Button type="button" onClick={onEnable} data-testid="mfa-enable-button">
            {t('mfa_enable_button')}
          </Button>
        )}
      </div>
    </section>
  );
}
